import { render } from "./EditProdukView.vue?vue&type=template&id=59bbad5e"
import script from "./EditProdukView.vue?vue&type=script&lang=js"
export * from "./EditProdukView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__